export class LongueurStation {
    id: number; // For IndexedDB
    mesureId: number;

    
    Longueur: number;

    static mapFromJSON(json: any): LongueurStation {
        const l = new LongueurStation();

        l.Longueur = json.longueur;

        return l;
    }
}